<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uNnX0L/tc-custom/9781453252963.jpg?1728726194193" alt="This image is the cover for the book All the Lucky Ones Are Dead, The Aaron Gunner Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All the Lucky Ones Are Dead, The Aaron Gunner Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Investigating the alleged suicide of a hip-hop star, Gunner uncovers a murder</b>Carlton Elbridge, better known as C. E. Digga Jones, was too nice for gangsta rap. When he allegedly shot himself, he had millions in the bank, his face on the cover of <i>Time</i> magazine, and a nation of fanatics to mourn his death. He was found in a locked room, gun in his hand and bullet in his brain, and the police assumed it was suicide. Only the rapper’s father thinks otherwise. Suspecting that his son was killed as the result of a hip-hop feud, Carlton’s father hires private detective Aaron Gunner to investigate the death. As Gunner tries to juggle the case with security work for a conservative black talk-show host, he learns that for some in the hip-hop world, the thug life is much more than an act.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gar Anthony Haywood
      </h2>
      
      <p class="authorDescription body article">Gar Anthony Haywood (b. 1954) is the Shamus Award&ndash;winning author of the Aaron Gunner mysteries. Born in Los Angeles, he spent over a decade as a computer technician before first publishing fiction in the 1980s. Influenced by a love for the Los Angeles mysteries of Ross Macdonald, he wrote <i>Fear of the Dark</i> (1987), winning the Shamus Award for best first novel and introducing the tough-nosed Los Angeles detective Aaron Gunner.&#160;Haywood continued the Gunner series through the bestselling <i>All the Lucky Ones Are Dead</i> (2000), and in between Gunner novels produced the two-book Loudermilk pair of seriocomic mysteries. Haywood also wrote two stand-alone thrillers, <i>Man Eater</i> (2003) and <i>Firecracker</i> (2004), under the pseudonym Ray Shannon, finding critical acclaim for both. He has written for newspapers and television, including an adaptation of the Dennis Rodman autobiography, <i>Bad as I Wanna Be</i>. His most recent novels are <i>Cemetery Road</i> (2010) and <i>Assume Nothing</i> (2011).<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fa5402ce